import React, { useState } from 'react';
import { useDistribution, } from '../../../../hooks';
import { DotsIcon } from '../../../../components/icons';
import { Container } from './styles';
import { Recipient } from '../../../../dtos';
import { ShareModal } from '../../../../components';
import theme from '../../../../theme';

const ShareDistributionRecipient: React.FC = () => {
    const [selectedRecipient, setSelectedRecipient] = useState<Recipient | null>(null);
    const { createdRecipients } = useDistribution();

    const renderShareModal = () => {
        if (!selectedRecipient) return null;
    
        return (
            <ShareModal
                selectedRecipient={selectedRecipient}
                handleClose={() => setSelectedRecipient(null)}
                options={['whatsapp', 'native-share']}
            />
        );
    };

    return (
        <Container>
            <small style={{ color: "#545453" }} >Compartilhe a cortesia:</small>
            <ul>
                {createdRecipients.map((recipient, index) => (
                    <li key={`recipient.${index}`}>
                        <div>
                            <small>{recipient.email}</small>
                            <small>{recipient.name}</small>
                            <strong>{recipient.phoneNumber || 'Número não informado'}</strong>
                        </div>
                        <DotsIcon iconColor={theme.primaryColor} onClick={() => setSelectedRecipient(recipient)} />
                    </li>
                ))}
            </ul>
            {renderShareModal()}
        </Container>
    );
};

export { ShareDistributionRecipient };
